import { Color, Border } from 'atomic'
import styled from 'styled-components'

export const SpecialistImageWrapper = styled.div`
  background-color: ${Color.GrayLight};
  border-radius: ${Border.Radius};
  overflow: hidden;
`
